/**
 * Version written to Detection.xml's ToolVersion attribute.
 *
 * This is the Content Prep Tool's semantic version (the value returned by
 * IntuneWinAppUtil.exe -v), not the Windows file/assembly version. Keeping it
 * numeric is important because Intune uses this field when reporting package
 * compatibility. The browser implementation remains unofficial; this value
 * only identifies the wire-format compatibility level we target.
 */
export const CONTENT_PREP_TOOL_VERSION = '1.8.7.0';

/** Honest identifier used when compatibility metadata is not enabled. */
export const LOCAL_TOOL_VERSION = 'LocalIntunePackageBuilder/0.1.0';

export function getToolVersion(useMicrosoftCompatibleMetadata = false): string {
  return useMicrosoftCompatibleMetadata ? CONTENT_PREP_TOOL_VERSION : LOCAL_TOOL_VERSION;
}
